import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'antd'
import Popover from '@components/common/Popover'
import ColorPicker from '@components/ColorPicker'
// import { GRADATION } from './helper'
// import { getEndGradationColor } from '../../src/common/gradationColorUtils'

const VALUE_RENDER_TYPES = [
  { value: 'negative', label: '负值' },
  { value: 'positive', label: '正值' },
]

const VALUE_TYPES = [
  { value: 'plain', label: '单色', icon: require('./images/bar-plain.svg') },
  { value: 'gradation', label: '渐变', icon: require('./images/bar-gradation.svg') },
]

export const getBarBackground = (gradationColors) => {
  let background
  if (Array.isArray(gradationColors) && gradationColors.length === 2) {
    // if (gradation) {
    //   background = `linear-gradient(90deg, ${getEndGradationColor(gradationColors[0])} 0%, ${gradationColors[0]} 50%, ${gradationColors[1]} 50%, ${getEndGradationColor(gradationColors[1])} 100%)`
    // } else {
    //   background = `linear-gradient(90deg, ${gradationColors[0]} 50%, ${gradationColors[1]} 50%)`
    // }
    background = `linear-gradient(90deg, ${gradationColors[0]} 50%, ${gradationColors[1]} 50%)`
  }

  return background
}

class BarStyle extends Component {
  static defaultProps = {}

  static propTypes = {
    condition: PropTypes.shape({
      visible: PropTypes.bool,

    }),
    index: PropTypes.number,
    handleChangeVisible: PropTypes.func,
    onColorPickerSure: PropTypes.func,
    onColorPickerHide: PropTypes.func,
    onBarChange: PropTypes.func,
  }

  render() {
    const { condition, handleChangeVisible } = this.props
    const { visible, styles } = condition
    const { color, gradation_colors: gradationColors } = styles

    return (
      <div className="cell" style={{ width: 50, flex: 0, flexShrink: 0 }}>
        <Dropdown
          trigger={['click']}
          overlay={this.renderColorMenu()}
          placement='bottomLeft'
          visible={visible}
          onVisibleChange={handleChangeVisible}
        >
          <div className="config-style-wrapper">
            {
              this.renderIcon(color, gradationColors)
            }
          </div>
        </Dropdown>
      </div>
    )
  }

  renderColorMenu() {
    const { condition, index, onColorPickerSure, onColorPickerHide, onBarChange } = this.props
    const { color, gradation_colors: gradationColors } = condition.styles
    const { value } = condition

    return (
      <div
        className="cells-dropdown-overlay bar-style-setting"
        style={{ width: 192, height: 220 }}>
        <div className="bar-value-type-wrapper">
          <div className="custom-option-label">
            填充类型
          </div>
          <div className="value-option-wrapper">
            {
              VALUE_TYPES.map(type => (
                <button onClick={() => onBarChange(index, type.value)} key={type.value} className={value === type.value ? 'active' : ''}>
                  <span style={{ backgroundImage: `url(${type.icon})` }}/>
                  {type.label}
                </button>
              ))
            }
          </div>
        </div>
        <hr/>
        <div className="bar-color-wrapper">
          {
            VALUE_RENDER_TYPES.map((valueType, valueIndex) => (
              <div key={valueType.value} className="color-wrapper">
                <Popover
                  content={
                    <ColorPicker
                      color={gradationColors[valueIndex] || 'transparent'}
                      changeAtOnce={false}
                      onSure={d => onColorPickerSure(index, 'barColor', d, valueType.value)}
                      onHide={onColorPickerHide}
                      disableAlpha
                    />
                  }
                  trigger="click"
                  overlayStyle={{ zIndex: 1060 }}
                  placement="bottomLeft"
                  className="table-cell-config-color-picker-popover-container"
                >
                  <span className="custom-option-round" style={{ background: gradationColors[valueIndex] || 'transparent' }}/>
                </Popover>
                <span className="custom-option-label">{valueType.label}</span>
              </div>
            ))
          }
        </div>
        <hr/>
        <div className="color-wrapper">
          <Popover
            content={
              <ColorPicker
                color={color || 'transparent'}
                changeAtOnce={false}
                onSure={d => onColorPickerSure(index, 'color', d)}
                onHide={onColorPickerHide}
                disableAlpha
              />
            }
            trigger="click"
            overlayStyle={{ zIndex: 1060 }}
            placement="bottomLeft"
            className="table-cell-config-color-picker-popover-container"
          >
            <span className="custom-option-round" style={{ background: color || 'transparent' }}/>
          </Popover>
          <span className="custom-option-label">文字</span>
        </div>
      </div>
    )
  }

  renderIcon(color, gradationColors) {
    const background = getBarBackground(gradationColors)

    return (<span className="config-gradation-wrapper" style={{ background }}>
      <i className="iconfont-date-filter icon-date-filter-default" style={{ color }}/>
    </span>)
  }
}

export default BarStyle
